import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "menu-base" }
const _hoisted_2 = { class: "menu-content" }




export default /*@__PURE__*/_defineComponent({
  __name: 'ChatMenu',
  emits: ["dialogueAction"],
  setup(__props, { emit: __emit }) {

const emits = __emit;

const dialogueAction = (index: number) => {
  emits("dialogueAction", index);
};

return (_ctx: any,_cache: any) => {
  const _component_Edit = _resolveComponent("Edit")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_Delete = _resolveComponent("Delete")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "menu-item",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (dialogueAction(0)))
      }, [
        _createVNode(_component_el_icon, { size: 20 }, {
          default: _withCtx(() => [
            _createVNode(_component_Edit)
          ]),
          _: 1
        }),
        _cache[2] || (_cache[2] = _createElementVNode("div", null, "编辑", -1))
      ]),
      _createElementVNode("div", {
        class: "menu-item red",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (dialogueAction(1)))
      }, [
        _createVNode(_component_el_icon, { size: 20 }, {
          default: _withCtx(() => [
            _createVNode(_component_Delete)
          ]),
          _: 1
        }),
        _cache[3] || (_cache[3] = _createElementVNode("div", null, "删除对话", -1))
      ])
    ])
  ]))
}
}

})